import posthog from 'posthog-js'

export default defineNuxtPlugin((nuxtApp) => {
    const runtimeConfig = useRuntimeConfig()
    const posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey, {
        defaults: '2025-05-24',
        api_host: runtimeConfig.public.posthogHost,
        loaded: (posthog) => {
            if (import.meta.env.MODE === 'development') posthog.debug()
        },
    })

    nuxtApp.hook('vue:error', (error) => {
        posthogClient.captureException(error)
    })

    return {
        provide: {
            posthog: () => posthogClient,
        },
    }
})